import React from 'react'
import { createPortal } from 'react-dom'

import SearchResults from 'components/shared/search/SearchResults'
import Button from 'components/shared/Button'
import classnames from 'classnames/bind'
import { ReactComponent as Search } from '../search-icon.svg'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const SearchBar = ({ indices, className, setIsSearching, isSearching }) => {
  return (
    <>
      <Button
        buttonClassName={css.buttonChildren}
        theme=""
        tagName="button"
        onClick={() => setIsSearching(true)}
        className={cx(css.SearchButton, className, { searching: isSearching })}
        border={css.border}
      >
        <Search className={css.icon} />
      </Button>
      {isSearching &&
        createPortal(
          <>
            <SearchResults
              className={css.results}
              indices={indices}
              closePopin={() => setIsSearching(false)}
            />
          </>,
          document.body
        )}
    </>
  )
}

SearchBar.defaultProps = {}

export default SearchBar
